<template>
  <b-card>
    <div v-if="!dataLoaded">
      <b-skeleton type="button" width="107px" class="mb-3"></b-skeleton>
      <div class="row">
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
        <div class="col-md-4">
          <b-skeleton height="330px"></b-skeleton>
        </div>
      </div>
    </div>

    <div v-if="dataLoaded">
      <b-button class="mb-3" variant="success" @click="showAddNewWallet"
        >کیف پول جدید</b-button
      >
      <div class="row">
        <div
          class="col-md-4"
          v-for="walletContent in walletList"
          v-bind:key="walletContent.id"
        >
          <b-card
            :img-src="require('@/assets/img/image_1.jpg')"
            img-top
            class="text-center"
            :title="walletContent.wallet_name"
          >
            <span>شناسه کیف پول:</span>
            <b>
              <span>{{ walletContent.wallet_number_id }}</span>
            </b>
            <div style="margin: 10px">
              <span>موجودی کیف پول:</span>
              <span
                >{{ toNumber(walletContent.ENmojudi) }}
                {{ walletContent.md12_title }}</span
              >
            </div>
            <b-button
              href="#"
              class="mr-3"
              variant="primary"
              @click="Transactions(walletContent.id)"
              >گردش</b-button
            >
            <b-button
              variant="primary"
              v-if="false"
              @click="ShowPayReqModal(walletContent)"
              >درخواست پرداخت</b-button
            >
          </b-card>
        </div>
      </div>
      <b-modal
        ref="addwallet-modal"
        :title="walletModalTitle"
        style="justify-content: space-around"
        @ok="sendAddOrEditWalletRequest"
        ok-title="ذخیره"
        cancel-title="بازگشت"
      >
        <b-form>
          <b-alert variant="danger" :show="AddEdit_error.length > 0">
            <p v-for="x in AddEdit_error" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-form-group
            id="input_wallet_name-group-1"
            label="نام کیف پول: "
            label-for="input_wallet_name-1"
          >
            <b-form-input
              id="input_wallet_name-1"
              required
              v-model="walletName"
              placeholder="عنوان "
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="mdid12_money_type-group-1"
            label="واحد پولی: "
            label-for="mdid12_money_type-1"
          >
            <MDDropdown
              v-bind:group="12"
              v-model="mdid12_money_type"
            ></MDDropdown>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-modal
        ref="payReq-modal"
        title="درخواست پرداخت"
        @ok="PayReq"
        ok-title="ذخیره"
        cancel-title="بازگشت"
      >
        <b-form>
          <b-alert variant="danger" :show="settlement_error.length > 0">
            <p v-for="x in settlement_error" v-bind:key="x">{{ x }}</p>
          </b-alert>
          <b-form-group
            id="wallet_name-group-1"
            label="نام کیف پول: "
            label-for="wallet_name-1"
          >
            <div class="form-control" disabled>
              {{ settlement.wallet_name }}
            </div>
          </b-form-group>
          <b-form-group id="cash-group-1" label="موجودی: " label-for="cash-1">
            <div class="form-control" disabled>{{ settlement.cash }}</div>
          </b-form-group>
          <b-form-group id="price-group-1" label="مبلغ: " label-for="price-1">
            <b-form-input
              id="price-1"
              required
              v-model="settlement.price"
              placeholder="عنوان "
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="user_card_id-group-1"
            label="کارت بانکی: "
            label-for="user_card_id-1"
          >
            <b-form-select
              id="user_card_id-2"
              v-model="settlement.user_card_id"
              :options="user_cards"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-modal>
    </div>
  </b-card>
</template>
<style>
.card.text-center .card-img-top {
  width: 200px;
  margin-top: 20px;
  text-align: center;
  margin: 20px auto auto auto;
}
</style>
<script>
import persianDate from "../../helpers/persianDate";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
export default {
  name: "irWalletList",
  data: function () {
    return {
      dataLoaded: false,
      loading: false,
      walletList: [],
      isInEditMode: false,
      walletName: null,
      mdid12_money_type: null,
      walletModalTitle: null,
      walletId: null,
      user_cards: [],
      settlement: {
        wallet_id: 0,
        user_card_id: 0,
        price: 0,
        wallet_name: "",
        cash: 0,
      },
      settlement_error: [],
      AddEdit_error: [],
    };
  },
  components: {
    MDDropdown,
  },
  created() {
    this.LoadWallets();
  },
  methods: {
    toNumber(number) {
      return Number(number).toLocaleString();
    },
    LoadWallets() {
      httpHelper.setAuth();
      httpHelper.getData("irwallets").then((res) => {
        this.walletList = res.result;
        this.dataLoaded = true;
      });
    },
    ShowPayReqModal(wallet) {
      httpHelper.getData("usercards").then((res) => {
        this.user_cards = res.result.map((element) => {
          return {
            text: element.nickname + " - " + element.account_number,
            value: element.id,
          };
        });
      });
      this.settlement.wallet_id = wallet.id;
      this.settlement.user_card_id = null;
      this.settlement.price = null;
      this.settlement.wallet_name = wallet.wallet_name;
      this.settlement.cash = wallet.mojudi;
      this.$refs["payReq-modal"].show();
    },
    PayReq(evt) {
      evt.preventDefault();
      if (this.loading) {
        return;
      }
      this.settlement_error = [];
      if (
        parseInt(this.settlement.price, 0) == 0 ||
        this.settlement.price == null
      ) {
        this.settlement_error.push("مبلغ را وارد کنید");
      }
      if (this.settlement.user_card_id == null) {
        this.settlement_error.push("کارت بانکی را انتخاب کنید");
      }
      if (parseInt(this.settlement.price, 0) > this.settlement.cash) {
        this.settlement_error.push("مبلغ درخواستی از مبلغ موجودی بیشتر است");
      }
      this.loading = true;
      if (this.settlement_error.length == 0) {
        httpHelper.postData("settlement", this.settlement).then((res) => {
          this.$refs["payReq-modal"].hide();
          this.LoadWallets();
          this.loading = true;
        });
      }
    },
    Transactions(id) {
      this.$router.push("/ir-wallet-transaction/" + id);
    },
    addNewWallet: function () {
      this.$router.push({ name: "addWallet" });
    },
    showAddNewWallet: function () {
      this.walletModalTitle = "اضافه کردن کیف پول جدید";
      this.showWalletModal();
    },
    showWalletModal: function () {
      this.$refs["addwallet-modal"].show();
    },
    sendAddOrEditWalletRequest: function (event) {
      event.preventDefault();
      if (this.loading) {
        return;
      }
      if (this.walletName == "" || this.walletName == null) {
        this.AddEdit_error.push("نام کیف پول را وارد کنید");
        return;
      }
      this.loading = true;
      httpHelper.setAuth();

      let walletData = {
        wallet_name: this.walletName,
        mdid12_money_type: this.mdid12_money_type,
      };

      if (this.isInEditMode) walletData.id = this.walletId;

      httpHelper.postData("wallets", walletData).then((response) => {
        if (response.success === true) {
          httpHelper
            .getData("wallets")
            .then((res) => {
              this.walletList = res.result;
              this.hideWalletModal();
              this.loading = false;
            })
            .finally(() => {});
        }
      });
    },
    hideWalletModal: function () {
      this.$refs["addwallet-modal"].hide();
    },
    editWalletName: function (wallet) {
      httpHelper.getData("wallets?id=" + wallet.id).then((response) => {
        if ((response.success = true)) {
          let walletInfo = response.result[0];
          this.walletName = walletInfo.wallet_name;
          this.walletId = walletInfo.id;
          this.isInEditMode = true;
          this.walletModalTitle = "ویرایش کیف پول";
          this.showWalletModal();
        }
      });
    },
  },
};
</script>
